export const camelize = function (str) {
  let arr = str.split("-");
  let capital = arr.map((item, index) =>
    index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item
  );
  // ^-- change here.
  let capitalString = capital.join("");
  return capitalString;
};

export const dependenciesCheck = function () {
  var passed = true;

  for (var i = 0; i < arguments.length; i++) {
    var argBooleanValue = !!(typeof arguments[i] === "string" ||
    arguments[i] instanceof jQuery
      ? arguments[i].length
      : arguments[i]);
    passed = passed && argBooleanValue;
  }

  return passed;
};

export const isTouchDevice = function () {
  return (
    "ontouchstart" in window ||
    navigator.MaxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};

/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 *`{leading: false}`. To disable execution on the trailing edge, ditto.
 * @param func
 * @param wait
 * @param options
 * @returns {function(): *}
 */
export const throttle = function (func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function () {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

export const announcementBarHeight = () => {
  const announcementBar = document.querySelector(".announcement-bar");
  if (announcementBar) {
    return announcementBar.clientHeight;
  } else {
    return 0;
  }
};

export const headerHeight = function () {
  const siteHeader = document.querySelector(".site-header");
  if (siteHeader) {
    const header = siteHeader.querySelector(".header__container");
    if (header) {
      if (siteHeader.classList.contains("headroom--unpinned")) {
        return header.clientHeight;
      } else {
        return header.clientHeight + announcementBarHeight();
      }
    } else {
      if (siteHeader.classList.contains("headroom--unpinned")) {
        return 0;
      } else {
        return announcementBarHeight();
      }
    }
  } else {
    return 0;
  }
};

export const addVariantToCart = async (
  variantId,
  quantity,
  successCallback,
  errorCallback
) => {
  await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [
        {
          id: parseInt(variantId),
          quantity: parseInt(quantity),
        },
      ],
    }),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (typeof successCallback === "function") successCallback(data);
      updateCartCount();
    })
    .catch((error) => {
      if (typeof errorCallback === "function") errorCallback(error);
      else console.error(`Error: ${error}`);
    });
};

export const updateVariantQty = async (
  lineId,
  variantId,
  quantity,
  successCallback,
  errorCallback
) => {
  const updates = {};
  updates[parseInt(lineId ?? variantId)] = parseInt(quantity);
  return await fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (typeof successCallback === "function") successCallback(data);
      updateCartCount();
      return data;
    })
    .catch((error) => {
      if (typeof errorCallback === "function") errorCallback(error);
      else console.error(`Error: ${error}`);
    });
};

export const getCart = async (successCallback, errorCallback) => {
  return await fetch(`${window.Shopify.routes.root}cart.js`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (typeof successCallback === "function") successCallback(data);
      return data;
    })
    .catch((error) => {
      if (typeof errorCallback === "function") errorCallback(error);
      else console.error(`Error: ${error}`);
    });
};

export const updateCartCount = async () => {
  const cartData = await getCart();
  document.querySelectorAll("[data-cart-count]").forEach((cartCounter) => {
    cartCounter.innerText = cartData.item_count;
    if (cartData.item_count <= 0)
      cartCounter.parentElement.classList.add("hide");
    else cartCounter.parentElement.classList.remove("hide");
  });
};
